import { render, staticRenderFns } from "./CountDetails.vue?vue&type=template&id=05ab961c&scoped=true&"
import script from "./CountDetails.vue?vue&type=script&lang=js&"
export * from "./CountDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ab961c",
  null
  
)

export default component.exports